import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';

const PagosTittle = ({ filters }) => {
    const { token } = useToken();
    const { showErrorToast } = useToast();

    const [cargando, setCargando] = useState(true);
    const [subtotalUSD, setSubtotalUSD] = useState(0);
    const [subtotalMXN, setSubtotalMXN] = useState(0);
    const [totalMXN, setTotalMXN] = useState(0);

    useEffect(() => {
        if (filters.month && filters.year) {
            ObtenerPagosTotales();
        }
    }, [
        filters.month,
        filters.year,
        filters.idCatCuentaBancaria,
        filters.idCatMedioPago,
        filters.idVendedor,
        filters.filterValidados,
        filters.filterStatus
    ]);

    const ObtenerPagosTotales = async () => {
        setCargando(true);
        const url = `/api/AdministracionPagos/ObtenerPagosTotales/?month=${filters.month}&year=${filters.year}&idCatCuentaBancaria=${filters.idCatCuentaBancaria}&idMedioPago=${filters.idCatMedioPago}&idVendedor=${filters.idVendedor}&iValidado=${filters.filterValidados}&iEstatus=${filters.filterStatus}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('' + error.message);
        });

        if (response && response.ok) {
            const objResponse = await response.json();
            if (objResponse.iResponseType == 1) {
                const data = JSON.parse(objResponse.detalles);
                setSubtotalUSD(data['table2']?.[0]?.SubtotalUSD || 0);
                setSubtotalMXN(data['table3']?.[0]?.SubtotalMXN || 0);
                setTotalMXN(data['table4']?.[0]?.totalMXN || 0);
            }
        }
        setCargando(false);
    };

    return (
        <Card className="mb-3 rounded-4 shadow-sm border-0">
            <Card.Body className="p-4">
                {cargando ? (
                    <Row className="align-items-center justify-content-between">
                        {/* LEFT SIDE SKELETON */}
                        <Col xs={12} lg="auto" className="d-flex align-items-center mb-3 mb-lg-0">
                            <Skeleton circle={false} borderRadius="1rem" height={52} width={52} className="me-3" />
                            <div>
                                <Skeleton width={200} height={24} className="mb-1" />
                                <br />
                                <Skeleton width={250} height={14} />
                            </div>
                        </Col>

                        {/* RIGHT SIDE SKELETON */}
                        <Col xs={12} lg="auto">
                            <div className="d-flex align-items-center flex-wrap gap-4">
                                <div className="text-end">
                                    <Skeleton width={90} height={14} className="mb-1" />
                                    <br />
                                    <Skeleton width={110} height={24} />
                                </div>
                                
                                <div className="bg-200" style={{ height: '40px', width: '1px' }}></div>
                                
                                <div className="text-end">
                                    <Skeleton width={90} height={14} className="mb-1" />
                                    <br />
                                    <Skeleton width={110} height={24} />
                                </div>
                                
                                <Skeleton width={150} height={65} borderRadius="1rem" />
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="align-items-center justify-content-between">
                        {/* LEFT SIDE: Title */}
                        <Col xs={12} lg="auto" className="d-flex align-items-center mb-3 mb-lg-0">
                            <div 
                                className="d-flex align-items-center justify-content-center me-3 shadow-sm" 
                                style={{ width: '52px', height: '52px', backgroundColor: '#e8fdf5', borderRadius: '1rem' }}
                            >
                                <img src="/img/ordenes96.png" alt="icon" width="28" />
                            </div>
                            <div>
                                <h4 className="mb-0 fw-bold text-dark">Conciliación de pagos</h4>
                                <span className="fs--1 text-500">Gestión y validación de registros financieros</span>
                            </div>
                        </Col>

                        {/* RIGHT SIDE: Totals */}
                        <Col xs={12} lg="auto">
                            <div className="d-flex align-items-center flex-wrap gap-4">
                                <div className="text-end">
                                    <h6 className="fs--2 text-500 mb-0 text-uppercase fw-bold letter-spacing-1">Subtotal MXN</h6>
                                    <h5 className="fs-0 text-dark fw-bold mb-0 mt-1">
                                        {subtotalMXN.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                    </h5>
                                    <h6 className="fs--2 text-400 mb-0 mt-1">IVA {(subtotalMXN - (subtotalMXN / 1.16)).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}</h6>
                                </div>
                                
                                <div className="bg-200" style={{ height: '45px', width: '1px' }}></div>
                                
                                <div className="text-end">
                                    <h6 className="fs--2 text-500 mb-0 text-uppercase fw-bold letter-spacing-1">Subtotal USD</h6>
                                    <h5 className="fs-0 text-dark fw-bold mb-0 mt-1">
                                        {subtotalUSD.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                    </h5>
                                    <h6 className="fs--2 text-400 mb-0 mt-1">IVA {(subtotalUSD - (subtotalUSD / 1.16)).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</h6>
                                </div>
                                
                                <div className="text-end px-4 py-2 shadow-sm" style={{ backgroundColor: '#e8fdf5', borderRadius: '1rem' }}>
                                    <h6 className="fs--2 mb-0 text-uppercase fw-bold letter-spacing-1" style={{ color: '#00d27a' }}>Total MXN</h6>
                                    <h4 className="fw-bold mb-0 mt-1" style={{ color: '#00d27a' }}>
                                        {totalMXN.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                    </h4>
                                    <h6 className="fs--2 mb-0 mt-1" style={{ color: '#00d27a', opacity: 0.75 }}>IVA {(totalMXN - (totalMXN / 1.16)).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}</h6>
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}
            </Card.Body>
        </Card>
    );
};

PagosTittle.propTypes = {
    filters: PropTypes.object.isRequired
};

export default PagosTittle;
